import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const InvoiceTrendChart = ({ data }) => {
  const months = data.map(item => item.month.substring(0, 3));

  const CCPaidColor = getComputedStyle(document.documentElement).getPropertyValue('--cd11').trim();
  const CCPendingColor = getComputedStyle(document.documentElement).getPropertyValue('--cd12').trim();
  const TCPaidColor = getComputedStyle(document.documentElement).getPropertyValue('--cd13').trim();
  const TCPendingColor = getComputedStyle(document.documentElement).getPropertyValue('--cd14').trim();
  const ToolTipBG = getComputedStyle(document.documentElement).getPropertyValue('--tooltip-bg').trim();
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 1500,
      easing: 'easeOutQuart'
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
    plugins: {
      datalabels: { display: false },
      title: {
        display: false,
        text: 'Invoice Trend',
        color: 'rgb(17, 56, 5)'
      },
      legend: {
        position: 'top',
        align: 'start',
        display: false,
        labels: {
          boxWidth: 12,
          padding: 20,
          font: {
            size: 10
          },
          usePointStyle: true,
          generateLabels: (chart) => {
            // Disable click events by making all labels unclickable
            return chart.data.datasets.map((dataset, i) => ({
              text: dataset.label,
              fillStyle: dataset.backgroundColor,
              strokeStyle: dataset.borderColor,
              lineWidth: 1,
              pointStyle: 'rect',
              hidden: false,
              // Disable click events
              datasetIndex: i
            }));
          }
        },
        // Disable click events
        onClick: null,
        onHover: null,
        onLeave: null
      },
      tooltip: {
        backgroundColor: ToolTipBG,
        padding: 12,
        titleFont: {
          size: 14
        },
        bodyFont: {
          size: 13
        },
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.parsed.y} Invoices`,
          afterBody: function(context) {
                                const index = context[0].dataIndex;
                                const newdata = data[index];
                                return [
                                    ` ` ,
                                    `    CC Total : ${newdata.CC.total} Invoices`,
                                    `    TC Total : ${newdata.TC.total} Invoices`
                                ];
                            }
        }
      }
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
          color: 'rgba(0, 0, 0, 0.1)'
        }
      },
      y: {
        beginAtZero: true,
        stacked: true,
        grid: {
          display: false,
          color: 'rgba(0, 0, 0, 0.1)'
        }
      }
    }
  };

  const chartData = {
    labels: data.map(item => item.month),
    datasets: [
      {
        label: 'CC Paid',
        data: data.map(item => item.CC.paid),
        backgroundColor: CCPaidColor,
        borderColor: CCPaidColor,
        borderWidth: 1,
        borderRadius: 5,
        stack: 'CC'
      },
      {
        label: 'CC Pending',
        data: data.map(item => item.CC.pending),
        backgroundColor: CCPendingColor,
        borderColor: CCPendingColor,
        borderWidth: 1,
        borderRadius: 5,
        stack: 'CC'
      },
      {
        label: 'TC Paid',
        data: data.map(item => item.TC.paid),
        backgroundColor: TCPaidColor,
        borderColor: TCPaidColor,
        borderWidth: 1,
        borderRadius: 5,
        stack: 'TC'
      },
      {
        label: 'TC Pending',
        data: data.map(item => item.TC.pending),
        backgroundColor: TCPendingColor,
        borderColor: TCPendingColor,
        borderWidth: 1,
        borderRadius: 5,
        stack: 'TC'
      }
    ]
  };

  return (
    <div className="chart-container">
      <Bar data={chartData} options={options} />
    </div>
  );
};

